<script>
	import {
		useCustomCss,
		showCustomCssButton,
		forceCustomCss,
		customCssButtonTextOff,
		customCssButtonTextOn,
		customCss,
		pages
	} from '../share/stores';
	import { fetchUrl } from '../share/utils';
	
	import PageContentParser from './PageContentParser.svelte';
	import Footer from "../partials/Footer.svelte";

	export let route;
	
	export let isRightSide;
	export let rightSideRendered;

	let _customCss = false;

	function readCustomCss(html) {
		if(!!_customCss) {
			return;
		}
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		if (tempDiv.querySelector('.meta[name*="auto_activate_custom_css"]') &&
			tempDiv.querySelector('.meta[name*="auto_activate_custom_css"]')?.getAttribute('content') === 'true') {
			useCustomCss.set('true');
		}
		if (tempDiv.querySelector('.meta[name*="show_custom_css_button"]') &&
				tempDiv.querySelector('.meta[name*="show_custom_css_button"]')?.getAttribute('content') === 'false') {
			showCustomCssButton.set(false);
		}
		if (tempDiv.querySelector('.meta[name*="force_custom_css"]')?.getAttribute('content') === 'true') {
			forceCustomCss.set(true);
		}
		if (tempDiv.querySelector('.meta[name*="custom_css_button_text_off"]') &&
			tempDiv.querySelector('.meta[name*="custom_css_button_text_off"]')?.getAttribute('content') !== '') {
			customCssButtonTextOff.set(tempDiv.querySelector('.meta[name*="custom_css_button_text_off"]').getAttribute('content'));
		}
		if (tempDiv.querySelector('.meta[name*="custom_css_button_text_on"]') &&
			tempDiv.querySelector('.meta[name*="custom_css_button_text_on"]')?.getAttribute('content') !== '') {
			customCssButtonTextOn.set(tempDiv.querySelector('.meta[name*="custom_css_button_text_on"]').getAttribute('content'));
		}

		Array.from(tempDiv.querySelectorAll('.meta[content*=".css"]')).forEach(meta => {
			meta.getAttribute('content').split(', ').forEach(async (src) => {
				if (src.endsWith('.css')) {
					const readCustomCss = await fetchUrl(route.split('#')[0] + (route !== '/' ? '/' : 'home/') + src);
					// css for page:
					_customCss = readCustomCss;
					// css for breadcrumb:
					if($pages.length < 2 || isRightSide) {
						customCss.set(readCustomCss);
					}
				}
			});
		});
		return true;
	}
</script>

{#await fetchUrl(route) then html}
	<ul class:isRightSide
		style={readCustomCss(html) && $forceCustomCss || $useCustomCss ? _customCss : ''}>
		<li>
			<PageContentParser {isRightSide} bind:rightSideRendered {html}/>
			<Footer/>
		</li>
	</ul>
{:catch error}
	<!-- load 404 if no other Content is available -->
	{#await fetchUrl('/404') then html}
		<PageContentParser {html} isRightSide={true} bind:rightSideRendered/>
		<Footer/>
	{:catch error}
		<h1>There's no fitting API-Response</h1>
	{/await}
{/await}

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	ul {
		position: relative;
		left: 0;
		z-index: 1;
		list-style: none;

		li {
			--li-gap: 2vmin;
			position: relative;
			z-index: 1;
			height: 100%;
			padding: 0;
			display: flex;
			flex-wrap: wrap;
			gap: var(--li-gap);
			
			h2 {
				line-height: 1.2em;
				display: block;
			}
		}
	}
</style>
